export default "__VITE_ASSET__cd519e7a__"